import React from "react";
import MenuHospitalPersonnel from "./navHospital/MenuHospitalPersonnel";
import Home from "../public/Home";

export default function HomeHospital() {
    // console.log("come here")
    return(
        <>
            <Home roleUser={'Hospital'}/>
        </>
    )
}